<template>
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M4 5h16l-6 8v6l-4-2v-4L4 5z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      vector-effect="non-scaling-stroke"
    />
  </svg>
</template>
